import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function FeaturedArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm">最新最热的白丝JK周边资讯与攻略</p>
          </div>
          <Link
            to="/category/shouban"
            className="px-5 py-2.5 rounded-full bg-background-50 text-foreground-700 text-sm font-medium hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap border border-background-200/70 flex items-center gap-1.5"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => {
            const cat = article.category;
            const categoryNames: Record<string, string> = {
              shouban: '手办周边',
              fuzhuang: 'JK服装',
              tongren: '同人文化',
              gouwu: '购物指南',
            };
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                      {categoryNames[cat] || cat}
                    </span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                    {article.summary}
                  </p>
                  <div className="flex items-center gap-2 mt-4">
                    <span className="text-xs text-foreground-400">{article.author}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}